import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/fission-header.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "rules" }
const _hoisted_3 = { class: "amount" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row tail" }
const _hoisted_7 = { class: "tips" }
const _hoisted_8 = {
  key: 0,
  class: "customer"
}
const _hoisted_9 = ["src"]

import { reactive, ref, onMounted } from "vue"
import { linkLoginInfo, linkUserLogin, orderQuery } from "@/utils/api"
import { toast } from "@/components/toast"
import Loading from '@/components/loading.vue'
import FloatNav from '@/components/floatnav.vue'
import { getUrlParam } from "@/utils/util"
import store from "@/store"

// 佣金是按照用户当月充值金额计算，梯度如下
// 你的粉丝激活当月充值100元以上可获得30元/户
// 备注:用户充值金额是指激活当月充值,当月激活未充值的用户无法返佣更多佣金额外奖励可以添加客服咨询了解



export default /*@__PURE__*/_defineComponent({
  __name: 'fission',
  setup(__props) {

const form = reactive({
    username: '',
    password: ''
})

const state = reactive({
    loading: false,
    show: false,
    shareUrl: '',
    text: '',
    amount: 0,
    qywx: '',
})
const items = ref<OrderItem[]>([])
const submit = async () => {
    if (!form.username) {
        toast('身份证号不能为空')
        return
    }
    const info: StoreState = store.getters
    state.loading = true
    const rsp = await linkUserLogin(form.username, form.password, info.fission, info.merchant)

    state.loading = false
    if (rsp.result == 0) {
        state.shareUrl = rsp.data.link_url
        state.text = ''
    } else {
        state.text = rsp.message
        state.show = true
        toast(rsp.message)
    }
}

const toLogin = () => {
    const adminUrl = "http://simadmin.zuxing.net"
    window.open(adminUrl, '_blank')
}

const fetchInfo = async () => {
    const info: StoreState = store.getters
    const rsp = await linkLoginInfo(info.merchant||3)
    if (rsp.result == 0) {
        state.shareUrl = rsp.data.link_url
        state.amount = rsp.data.amount
        state.qywx = rsp.data.qywx
    }
}

onMounted(() => {
    fetchInfo()
    const id = getUrlParam('uid')
    form.username = id
    if (id) {
        submit()
    }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("img", {
      src: _imports_0,
      alt: "邀请好友赚现金",
      class: "header"
    }, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "title" }, [
      _createElementVNode("div", { class: "tag" }, " "),
      _createTextVNode("活动规则 ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[3] || (_cache[3] = _createTextVNode("转发您的专属链接，有人下单且激活电话卡后, 可获得 ")),
        _createElementVNode("span", _hoisted_3, _toDisplayString(state.amount) + "元", 1),
        _cache[4] || (_cache[4] = _createTextVNode("佣金奖励。"))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, "登录获取专属链接", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", null, "如没有账号，在下面注册后即可获取专属链接", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", null, "密码丢失请添加推广客服", -1))
    ]),
    _createElementVNode("div", {
      class: "tologin",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toLogin()))
    }, "已有账号, 前往登录 >"),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "required" }, "*", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, "电话号码", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.username) = $event)),
          type: "text",
          class: "input",
          placeholder: "请输入您的手机号"
        }, null, 512), [
          [_vModelText, form.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "required" }, "*", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label" }, "密码", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.password) = $event)),
          type: "password",
          class: "input",
          placeholder: "长度为6-12位"
        }, null, 512), [
          [_vModelText, form.password]
        ])
      ]),
      _createElementVNode("div", {
        class: "btn",
        onClick: submit
      }, "注册赚佣金"),
      _createElementVNode("div", _hoisted_7, _toDisplayString(state.text), 1)
    ]),
    (state.qywx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text" }, "添加推广客服不迷路", -1)),
          _createElementVNode("img", {
            src: state.qywx,
            alt: "推广客服二维码"
          }, null, 8, _hoisted_9)
        ]))
      : _createCommentVNode("", true),
    (state.loading)
      ? (_openBlock(), _createBlock(Loading, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(FloatNav, {
      auth: false,
      fission: false,
      query: false
    })
  ]))
}
}

})